const createUserFormFields = () => [
    {
        id: 'name',
        label: 'Name',
        name: 'name',
        type: 'text',
        placeholder: 'e.g. John Doe',
        helperText: 'New user full name',
        component: 'FormikTextField',
        xs: 12,
        sm: 6,
        md: 6,

    },
    {
        id: 'email',
        label: 'Email',
        name: 'email',
        type: 'email',
        placeholder: 'e.g. john.doe@domain.com',
        helperText: 'New user email address. (required to authenticate users)',
        component: 'FormikTextField',
        xs: 12,
        sm: 6,
        md: 6,
    },
    {
        id: 'phone',
        label: 'Phone',
        name: 'phone',
        type: 'phone',
        placeholder: 'e.g. +44771234567890',
        component: 'FormikTextField',
        xs: 12,
        sm: 6,
        md: 6,
    },
    {
        id: 'qsId',
        label: 'Qlik Sense User Id',
        name: 'qsId',
        type: 'text',
        placeholder: 'e.g. John.Doe',
        helperText: 'User\'s Qlik Sense User ID',
        component: 'FormikTextField',
        xs: 12,
        sm: 6,
        md: 6,
    },
    {
        id: 'directory',
        label: 'Qlik Sense User Directory',
        name: 'directory',
        type: 'text',
        placeholder: 'e.g. COEUS',
        helperText: 'User\'s Qlik Sense Directory',
        component: 'FormikTextField',
        xs: 12,
        sm: 6,
        md: 6,
    },
    {
        id: 'role',
        label: 'User Role',
        name: 'role',
        placeholder: 'Select Role',
        helperText: 'Select a user COEUS role',
        component: 'FormikSelect',
        items: [
            {
                value: 'Admin',
                label: 'Admin',
            },
            {
                value: 'User',
                label: 'User',
            },
        ],
        xs: 12,
        sm: 6,
        md: 6,
    },
    {
        id: 'password',
        label: 'Password',
        name: 'password',
        type: 'password',
        placeholder: '',
        component: 'FormikTextField',
        xs: 12,
        sm: 6,
        md: 6,
    },
    {
        id: 'confirm_password',
        label: 'Confirm password',
        name: 'confirm_password',
        type: 'password',
        placeholder: '',
        component: 'FormikTextField',
        xs: 12,
        sm: 6,
        md: 6,
    },
    {
        id: 'emailVerified',
        label: 'Email Address Verified',
        name: 'emailVerified',
        component: 'FormikCheckbox',
        xs: 12,
        sm: 6,
        md: 6,
    },
    {
        id: 'sendWelcomeEmail',
        label: 'Send Welcome Email',
        name: 'sendWelcomeEmail',
        component: 'FormikCheckbox',
        xs: 12,
        sm: 6,
        md: 6,
    },
]
export default createUserFormFields;
